export default "__VITE_ASSET__BByJpYne__"